var img = "data:image/svg+xml,%3csvg height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='m17.04 11.335-5.241-5.241 1.093-1.094 7.108 7.108-7.108 7.108-1.093-1.094 5.24-5.24h-13.039v-1.547z' fill='currentColor'/%3e%3c/svg%3e";

export default img;
//# sourceMappingURL=arrow.svg.js.map
